import axios from "axios";

export const TOKEN_KEY = "nq_token";
export const NIFTY50 = ["NIFTY50", "BANKNIFTY", "RELIANCE", "TCS", "HDFCBANK", "ICICIBANK", "INFY", "SBIN", "ITC", "LT", "MARUTI", "HINDUNILVR", "BHARTIARTL", "KOTAKBANK", "BAJFINANCE", "AXISBANK", "ASIANPAINT", "SUNPHARMA", "TITAN", "ULTRACEMCO", "WIPRO", "NESTLEIND", "ONGC", "NTPC", "POWERGRID", "M&M", "HCLTECH", "TATAMOTORS", "TATASTEEL", "JSWSTEEL", "ADANIENT", "ADANIPORTS", "COALINDIA", "BAJAJFINSV", "GRASIM", "HDFCLIFE", "SBILIFE", "BPCL", "BRITANNIA", "CIPLA", "DRREDDY", "EICHERMOT", "HEROMOTOCO", "HINDALCO", "INDUSINDBK", "APOLLOHOSP", "BAJAJ-AUTO", "TECHM", "TATACONSUM", "LTIM", "SHRIRAMFIN", "TRENT", "BEL", "JIOFIN"];
export const SYMBOL_SECTORS = { NIFTY50: "Index", BANKNIFTY: "Index", RELIANCE: "Energy", TCS: "IT", HDFCBANK: "Bank", ICICIBANK: "Bank", INFY: "IT", SBIN: "Bank", ITC: "FMCG", LT: "Infra", MARUTI: "Auto", HINDUNILVR: "FMCG", BHARTIARTL: "Telecom", KOTAKBANK: "Bank", BAJFINANCE: "NBFC", AXISBANK: "Bank", ASIANPAINT: "FMCG", SUNPHARMA: "Pharma", TITAN: "Consumer", ULTRACEMCO: "Cement", WIPRO: "IT", NESTLEIND: "FMCG", ONGC: "Energy", NTPC: "Power", POWERGRID: "Power", "M&M": "Auto", HCLTECH: "IT", TATAMOTORS: "Auto", TATASTEEL: "Metal", JSWSTEEL: "Metal", ADANIENT: "Diversified", ADANIPORTS: "Infra", COALINDIA: "Mining", BAJAJFINSV: "NBFC", GRASIM: "Cement", HDFCLIFE: "Insurance", SBILIFE: "Insurance", BPCL: "Energy", BRITANNIA: "FMCG", CIPLA: "Pharma", DRREDDY: "Pharma", EICHERMOT: "Auto", HEROMOTOCO: "Auto", HINDALCO: "Metal", INDUSINDBK: "Bank", APOLLOHOSP: "Healthcare", "BAJAJ-AUTO": "Auto", TECHM: "IT", TATACONSUM: "FMCG", LTIM: "IT", SHRIRAMFIN: "NBFC", TRENT: "Retail", BEL: "Defence", JIOFIN: "NBFC" };
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && getToken()) {
    localStorage.removeItem(TOKEN_KEY);
    window.dispatchEvent(new Event("nq-logout"));
  }
  return Promise.reject(e);
});

export const IST_OFFSET = 19800;
export const TIMEFRAMES = ["1m", "5m", "15m", "1h", "1D"];

export const inr = (v, d = 2) =>
  v == null || Number.isNaN(v)
    ? "—"
    : `${v < 0 ? "-" : ""}₹${Math.abs(Number(v)).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d })}`;

export const num = (v, d = 2) =>
  v == null ? "—" : Number(v).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });

export const pct = (v) => (v == null ? "—" : `${v >= 0 ? "+" : ""}${Number(v).toFixed(2)}%`);

export const tone = (v) => (v > 0 ? "text-bull" : v < 0 ? "text-bear" : "text-slate-400");

export const fmtTs = (ts) =>
  new Date((typeof ts === "number" ? ts * 1000 : ts)).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false,
  });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};
